import * as React from 'react';
import { useState, createContext, useContext } from 'react';

interface KartstodContextTyp {
  isSokKoordinaterOpen: boolean;
  isRitverktygOpen: boolean;
  isInstallningarOpen: boolean;
  setIsSokKoordinaterOpen: (visaSokKoordinater: boolean) => void;
  setIsRitverktygOpen: (visaRitverktyg: boolean) => void;
  setIsInstallningarOpen: (visaInstallningar: boolean) => void;

  visaFelmeddelande: boolean;
  felmeddelande: string;
  setVisaFelmeddelande: (visaFelmeddelande: boolean) => void;
  setFelmeddelande: (felMeddelande: string) => void;
}

const KartstodContext = createContext<KartstodContextTyp | undefined>(
  undefined
);

type KartstodContextProviderProps = { children: React.ReactNode };

function KartstodProvider({ children }: KartstodContextProviderProps) {
  const [isSokKoordinaterOpen, setIsSokKoordinaterOpen] =
    useState<boolean>(false);
  const [isRitverktygOpen, setIsRitverktygOpen] = useState<boolean>(false);
  const [isInstallningarOpen, setIsInstallningarOpen] =
    useState<boolean>(false);

  const [visaFelmeddelande, setVisaFelmeddelande] = useState(false);
  const [felmeddelande, setFelmeddelande] = useState('');

  const value = {
    isSokKoordinaterOpen,
    setIsSokKoordinaterOpen,
    isRitverktygOpen,
    setIsRitverktygOpen,
    isInstallningarOpen,
    setIsInstallningarOpen,
    visaFelmeddelande,
    setVisaFelmeddelande,
    felmeddelande,
    setFelmeddelande,
  };

  return (
    <KartstodContext.Provider value={value}>
      {children}
    </KartstodContext.Provider>
  );
}

function useKartstodContext() {
  const context = useContext(KartstodContext);
  if (context === undefined) {
    throw new Error('React must be used within a KartstodContextProvider');
  }
  return context;
}

export { KartstodProvider, useKartstodContext };
